import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { NavLink } from 'react-router-dom'
import classes from './Link.module.scss'


const LinkComponent = (
  {
    path,
    label,
    size,
    color,
    position,
    className,
    isExternalLink,
  },
) => {
  const { t } = useTranslation('common_volunteering')

  return (
    <div
      className={clsx(
        position,
        classes.wrapperLinkBtn,
        classes[size],
        'd-flex',
        className,
      )}>
      {isExternalLink ? (
        <a
          href={path}
          rel="noreferrer"
          target="_blank"
          className={clsx(
            classes.wrapperLink,
            classes[size],
            classes[color],
          )}>
          {t(label)}
        </a>
      ) : (
        <NavLink
          to={path}
          className={clsx(
            classes.wrapperLink,
            classes[size],
            classes[color],
          )}>
          {t(label)}
        </NavLink>
      )}
    </div>
  )
}


LinkComponent.propTypes = {
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  size: PropTypes.oneOf(['small', 'medium', 'large', 'maxWidth', 'custom']),
  color: PropTypes.oneOf(['primaryColor', 'secondaryColor', 'custom']),
  position: PropTypes.oneOf(['justify-content-start', 'justify-content-center', 'justify-content-end']),
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  className: PropTypes.string,
  isExternalLink: PropTypes.bool,
}

LinkComponent.defaultProps = {
  path: '',
  size: 'medium',
  color: 'primaryColor',
  position: 'justify-content-start',
  label: '',
  className: '',
  isExternalLink: false,
}

export default LinkComponent
